import { z } from "zod";
import UsersService from "../../../services/UserService";
import { mapErrorsToFields } from "../../../utils";
import { User } from "../../../models";
const api = new UsersService();
export type State = {
  errors?: {
    name?: string[];    
    general?: string[];
  };
  success?: boolean;
  message?: string | null;
  defaultValues?: {
    name?: string;    
    phone?: string;
    address?: string;
    dob?: string;
  };
};

const FormSchema = z.object({
  name: z.string().min(3, { message: "Name must be at least 3 characters." }),  
  phone: z.string().optional(),
  address: z.string().optional(),
  dob: z.string().optional(),
  profileImage: z.any().optional(),
});

export async function updateProfile(
  userId: string,
  prevState: State,
  formData: FormData
): Promise<State> {
  const profileImage = formData.get("profileImage") as File;
  console.log({ profileImage });

  const defaultValues = {
    name: formData.get("name")?.toString() || "",    
    phone: formData.get("phone")?.toString() || "",
    address: formData.get("address")?.toString() || "",
    dob: formData.get("dob")?.toString() || "",
  };
  const validatedFields = FormSchema.safeParse(defaultValues);

  if (!validatedFields.success) {
    const errors = mapErrorsToFields(validatedFields.error);
    return {
      ...prevState,
      errors,
      message: "Validation failed.",
      success: false,
    };
  }
  
  try {

    // upload image
    if (profileImage && profileImage.name != "")
      await api.uploadUserProfile(profileImage);
    if(!defaultValues.dob)
      (defaultValues.dob as any) = null;
    const response = await api.updateMyProfile(defaultValues);
    if (response.status === 200) {
      return {
        success: true,
        message: "Profile updated successfully.",
        errors: {},
        defaultValues: defaultValues,
      };
    }
    return {
      ...prevState,
      success: false,
      message: "Failed to update profile.",
      errors: {},
    };
  } catch (error: any) {
    return {
      ...prevState,
      success: false,
      message: error.response?.data?.message || "An unexpected error occurred.",
      errors: {},
    };
  }
}
